module.exports = __webpack_public_path__ + "img/r-50.9b0593e0.jpg";